/**
 * Created by lihanying on 2017/7/6.
 */
import { GETCLUBDEPLOYLIST, GETDEPLOYINFO } from './constants'

const initState = {}

export default function (state = initState, action) {
  switch (action.type) {
    case GETCLUBDEPLOYLIST:
      return Object.assign({}, state, { deployList: action.payload })
    case GETDEPLOYINFO:
      return Object.assign({}, state, { deployInfo: action.payload })

    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/containers/ClubDeploy/reduce.js